module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//btn-3.png?v=bce6c08b";